<template>
  <search-layout>
    <template v-slot:contents>
      <v-flex class="certificate-type-container">
        <div class="certificate-type" v-for="(type, index) in certificateTypeList" :key="index">
          <v-card class="certificate-type-card" :class="{'is-admin': isAdmin}" elevation="0" @click="showSignup(type)">
            <span>{{ brokenTitle(type.text) }}</span>
          </v-card>
        </div>
      </v-flex>
      <certificate-signup
          :is-show="isShowSignup"
          :select-data="selectData"
          @refresh="$emit('refresh')"
          @close="isShowSignup = false"
      />
      <business-card-signup
          :is-show="isShowBusinessCard"
          :select-data="selectData"
          popup-type="create"
          @refresh="$emit('refresh')"
          @close="isShowBusinessCard = false"
      />
    </template>
  </search-layout>
</template>
<script>
import CertificateSignup from "@/pages/Certificate/popup/CertificateSignup.vue";
import constant from "@/util/constant";
import SearchLayout from "@/common/layout/SearchLayout.vue";
import {mapGetters} from "vuex";
import BusinessCardSignup from "@/pages/Certificate/popup/BusinessCardSignup.vue";

export default {
  name: "CertificateTypeList",
  components: {BusinessCardSignup, SearchLayout, CertificateSignup},
  data() {
    return {
      certificateTypeList: constant.CERTIFICATE_TYPE_LIST,
      isShowSignup: false,
      isShowBusinessCard: false,
      selectData: {}
    }
  },
  computed: {
    ...mapGetters("login", {
      memberRole: "memberRole"
    }),
    isAdmin() {
      return this.memberRole === "ADMIN";
    }
  },
  methods: {
    showSignup(typeData) {
      if (this.isAdmin) {
        return false;
      }
      if (typeData.value === "명함신청") {
        this.isShowBusinessCard = true;
      } else {
        this.isShowSignup = true;
      }
      this.selectData = typeData;
    },
    brokenTitle(title) {
      return title.replace("(", "\u200B(");
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/Certificate/CertificateTypeList.scss";
</style>